import compose from 'utils/composeEnhancer'
import handleFeedbackStore from 'hooks/handleFeedbackStore'

export default compose(handleFeedbackStore)
